exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form_content {\n  margin-top: 20px;\n}\n.step {\n  margin-top: 15px;\n}\n.step .el-step.is-center .el-step__description {\n  font-size: 11px;\n  line-height: 1.2;\n  padding: 15px 0 0;\n}", ""]);

// exports
